import { Button, Spin } from "antd";
// import PhasePatientList from 'Components/Pages/Dashboard/PhasePatientList'
import ScheduleList from "Components/Pages/Dashboard/ScheduleList";
import React, { memo, useCallback, useEffect, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Timer from "../../../../Img/Timer.svg";
import Calendar from "react-calendar";
import PhasePatientList from "./PhasePatientList";
import {
  getPhseWisePatient,
  getScheduleList,
  setScheduleDate,
  setScheduleStartPage,
  setShowReminderModal,
} from "redux/reducers/Dashboard/dashboard.slice";
import { formatDate } from "Components/Pages/KPI/kpiHelpers";
import moment from "moment";
import ReminderModal from "Components/Pages/Dashboard/ReminderModal";

const Dashboard = () => {
  const ref = useRef();
  const dispatch = useDispatch();
  const scheduleLimit = null;

  const { selectedLocation } = useSelector(({ role }) => role);
  const { scheduleObject, scheduleStartPage, scheduleDate, dashboardLoading } =
    useSelector(({ dashboard }) => dashboard);

  const fetchPhase = () => {
    const payload = {
      filter_location_id: selectedLocation,
      phase: [1, 2, 3, 4],
    };

    dispatch(
      getPhseWisePatient({
        location_id: selectedLocation,
        start: null,
        limit: scheduleLimit,
        payload: payload,
      })
    );
  };

  useEffect(() => {
    if (selectedLocation) {
      fetchPhase();
    }
  }, [selectedLocation]);

  const callGetScheduleList = useCallback(
    (start, limit, locationId, date, prevData = {}) => {
      dispatch(
        getScheduleList({
          start,
          limit,
          location_id: locationId,
          date: moment(date).format("YYYY-MM-DD"),
          prevData,
        })
      );
    },
    [dispatch]
  );

  useEffect(() => {
    if (selectedLocation && scheduleStartPage) {
      callGetScheduleList(
        scheduleStartPage,
        scheduleLimit,
        selectedLocation,
        scheduleDate,
        scheduleObject
      );
    }
  }, [selectedLocation, scheduleStartPage]);

  const changeDate = (e) => {
    if (formatDate(e) !== formatDate(scheduleDate)) {
      dispatch(setScheduleDate(moment(e).format("YYYY-MM-DD")));
      callGetScheduleList(1, scheduleLimit, selectedLocation, e);
      dispatch(setScheduleStartPage(1));
    }
  };

  const onScroll = () => {
    const container = ref.current;
    if (!container) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    const isAtBottom =
      scrollTop && Math.ceil(scrollTop + clientHeight) >= scrollHeight;

    const hasMoreItems =
      scheduleObject?.scheduleList?.length < scheduleObject?.scheduleListCount;

    if (isAtBottom && hasMoreItems) {
      dispatch(setScheduleStartPage(scheduleStartPage + 1));
    }
  };

  return (
    <div className="dashboard_tab">
      {dashboardLoading && (
        <Spin tip="Loading" size="large">
          <div className="content" />
        </Spin>
      )}
      <div className="home_list_area">
        <Row className="m-0">
          <Col lg={6} className="patient_list">
            <PhasePatientList />
          </Col>
          <Col lg={6} className="schedule">
            <div className="home_calendar_title">
              <h3 className="m-0">Today’s Schedule</h3>
              <Button
                className="btn_primary reminder_btn mb24"
                onClick={() => dispatch(setShowReminderModal(true))}
              >
                <img src={Timer} alt="" />
                Reminder
              </Button>
            </div>
            <div className="d-xxl-flex d-lg-block d-md-flex schedule_partition">
              <Col xxl={6} lg={12} md={6} className="home_calendar">
                <Calendar
                  value={scheduleDate}
                  onChange={changeDate}
                  className="date_calendar"
                />
              </Col>
              <Col
                xxl={6}
                lg={12}
                md={6}
                className="user_list"
                ref={ref}
                onScroll={onScroll}
              >
                <ScheduleList />
              </Col>
            </div>
          </Col>
        </Row>
      </div>
      <ReminderModal />
    </div>
  );
};

export default memo(Dashboard);
